(function () {
  const BASE = 'cart-drawer-note-polish-v5.js';
  const STYLE = 'ellerow-cart-final-v13';

  function baseUrl() {
    const current = document.currentScript;
    if (current && current.src) return new URL(BASE, current.src).toString();
    const loader = Array.from(document.scripts || []).find((script) => script.src && script.src.includes('cart-drawer-note.js'));
    return loader ? new URL(BASE, loader.src).toString() : BASE;
  }

  function syncPreviewBar() {
    document.documentElement.classList.toggle('ellerow-shopify-preview-bar-active', !!document.getElementById('PBarNextFrameWrapper'));
  }

  function stripCartTaxNoteLinks() {
    const notes = document.querySelectorAll('#CartDrawer .wt-cart__subtitle__text, #CartDrawer .tax-note, #CartDrawer .cart__ctas+small');
    notes.forEach((note) => {
      const text = (note.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!text.includes('taxes') || !text.includes('shipping') || !text.includes('checkout')) return;
      note.querySelectorAll('a').forEach((link) => {
        link.replaceWith(document.createTextNode(link.textContent || ''));
      });
    });
  }

  function cartQuantityFromText(text) {
    const match = String(text || '').match(/\d+/);
    return match ? match[0] : '';
  }

  function preferredCartQuantity(candidates) {
    const values = candidates
      .map((value) => cartQuantityFromText(value))
      .filter(Boolean);
    return values.find((value) => Number(value) > 0) || values[0] || '';
  }

  function drawerItemQuantity() {
    const inputs = Array.from(document.querySelectorAll([
      '#CartDrawer .wt-cart__drawer__body .counter input',
      '#CartDrawer .wt-cart__drawer__body quantity-input input',
      '#CartDrawer .wt-cart__drawer__body input[name^="updates"]',
      '#CartDrawer .wt-cart__drawer__body input[name="quantity"]'
    ].join(',')));

    const sum = inputs.reduce((total, input) => {
      const value = Number(input.value || input.getAttribute('value') || 0);
      return Number.isFinite(value) && value > 0 ? total + value : total;
    }, 0);

    return sum > 0 ? String(sum) : '';
  }

  function cartTriggerQuantity() {
    const trigger = document.querySelector('a.wt-cart__trigger[href="/cart"], a[href="/cart"]');
    if (!trigger) return '';

    return preferredCartQuantity([
      trigger.querySelector('[data-cart-count]')?.textContent,
      trigger.querySelector('.cart-count-bubble, .cart-count, .wt-cart__counter, .counter, [class*="count" i]')?.textContent,
      trigger.getAttribute('aria-label'),
      trigger.textContent
    ]);
  }

  function cartQuantity(title) {
    return preferredCartQuantity([
      drawerItemQuantity(),
      cartTriggerQuantity(),
      document.querySelector('#CartDrawer .wt-cart__drawer-title-count')?.textContent,
      title && title.textContent
    ]);
  }

  function normalizeCartTitle() {
    const title = document.querySelector('#CartDrawer #CartDrawer-TotalQty, #CartDrawer .wt-cart__drawer__title, #CartDrawer .drawer__heading');
    if (!title) return;

    const count = cartQuantity(title);
    const html = `<span class="wt-cart__drawer-title-word">CART</span>${count ? `<span class="wt-cart__drawer-title-count">${count}</span>` : ''}`;
    title.id = 'CartDrawer-TotalQty';
    title.setAttribute('aria-label', count ? `CART ${count}` : 'CART');
    if (title.innerHTML !== html) title.innerHTML = html;
  }

  function syncEmptyCartFontClass() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    const hasItem = !!drawer.querySelector('#CartDrawer .wt-cart__item, #CartDrawer .cart-item, #CartDrawer [id^="CartDrawer-Item"]');
    const hasEmptyState = !!drawer.querySelector('#CartDrawer .wt-cart__empty, #CartDrawer .cart__empty-text, #CartDrawer .cart-drawer__empty-content, #CartDrawer [class*="empty" i]');
    const title = drawer.querySelector('#CartDrawer-TotalQty, .wt-cart__drawer__title, .drawer__heading');
    const quantity = Number(cartQuantity(title) || 0);

    drawer.classList.toggle('ellerow-cart-empty', !hasItem && (hasEmptyState || quantity === 0));
  }

  function syncCartTitleSoon() {
    [0, 120, 500, 1200, 2400].forEach((delay) => {
      setTimeout(() => {
        normalizeCartTitle();
        syncEmptyCartFontClass();
      }, delay);
    });
  }

  function bindCartTitleSync() {
    if (window.__ellerowCartTitleSyncBound) return;
    window.__ellerowCartTitleSyncBound = true;

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (target.closest('a.wt-cart__trigger[href="/cart"], a[href="/cart"], #CartDrawer .counter button, #CartDrawer quantity-input button, #CartDrawer cart-remove-button, #CartDrawer .cart-remove-button')) {
        syncCartTitleSoon();
      }
    }, true);

    const drawer = document.getElementById('CartDrawer');
    if (drawer) {
      new MutationObserver(syncCartTitleSoon).observe(drawer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'value', 'open']
      });
    }
  }

  function setNoteTabindex(host, value) {
    const body = host && host.querySelector('.giftnote__body');
    if (!body) return;
    body.querySelectorAll('button, [href], input, select, textarea, [tabindex]').forEach((element) => {
      element.setAttribute('tabindex', value);
    });
  }

  function openCartNote(host) {
    if (!host) return;
    host.setAttribute('open', '');
    setNoteTabindex(host, '0');
    setTimeout(() => {
      const focusTarget = host.querySelector('.giftnote__body__close, #CartDrawer-note, textarea');
      focusTarget?.focus?.();
    }, 0);
  }

  function closeCartNote(host) {
    if (!host) return;
    host.removeAttribute('open');
    setNoteTabindex(host, '-1');
    setTimeout(() => host.querySelector('.giftnote__drawercart__addnote')?.focus?.(), 0);
  }

  function saveCartNote(host) {
    const note = document.getElementById('CartDrawer-note')?.value || '';
    const url = window.routes?.cart_update_url || '/cart/update.js';
    const config = typeof window.fetchConfig === 'function'
      ? window.fetchConfig()
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };

    fetch(url, { ...config, body: JSON.stringify({ note }) }).catch(() => {});
    closeCartNote(host);
  }

  function stopCartNoteClick(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation?.();
  }

  function bindCartNoteFallback() {
    if (window.__ellerowCartNoteFallbackBound) return;
    window.__ellerowCartNoteFallbackBound = true;

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const trigger = target.closest('#CartDrawer .giftnote__drawercart__addnote');
      const close = target.closest('#CartDrawer .giftnote__body__close, #CartDrawer .giftnote__overlay');
      const save = target.closest('#CartDrawer .giftnote__save');
      if (!trigger && !close && !save) return;

      const host = target.closest('drawer-cart-note') || document.querySelector('#CartDrawer drawer-cart-note');
      if (!host) return;

      stopCartNoteClick(event);
      if (trigger) openCartNote(host);
      if (close) closeCartNote(host);
      if (save) saveCartNote(host);
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const host = document.querySelector('#CartDrawer drawer-cart-note[open]');
      if (host) closeCartNote(host);
    }, true);
  }

  function inject() {
    syncPreviewBar();
    const old = document.getElementById(STYLE);
    if (old) old.remove();

    const hidden = 'display:none!important;visibility:hidden!important;opacity:0!important;height:0!important;min-height:0!important;max-height:0!important;margin:0!important;padding:0!important;overflow:hidden!important;pointer-events:none!important;';
    const style = document.createElement('style');
    style.id = STYLE;
    style.textContent = `
      #CartDrawer .wt-cart__subtitle__text a,
      #CartDrawer .tax-note a,
      #CartDrawer .cart__ctas+small a { color:inherit!important; text-decoration:none!important; pointer-events:none!important; cursor:default!important; }
      #CartDrawer #xcottonWrapper .xcotton-money,
      #CartDrawer #xcottonWrapper .xcotton-money-row { font-weight:400!important; }
      #CartDrawer drawer-cart-note[open] .giftnote__body { visibility:visible!important; opacity:1!important; pointer-events:auto!important; transform:translateY(0)!important; }
      #CartDrawer drawer-cart-note[open] .giftnote__overlay { display:block!important; visibility:visible!important; pointer-events:auto!important; }
      #CartDrawer.ellerow-cart-empty,
      #CartDrawer.ellerow-cart-empty * { font-family:Montserrat,var(--font-body-family),-apple-system,BlinkMacSystemFont,sans-serif!important; }

      @media screen and (max-width: 749px) {
        #CartDrawer .xctton-side-cart-offer,
        #CartDrawer .xctton-side-cart-offer-btn,
        #CartDrawer .ellerow-desktop-view-cart,
        #CartDrawer .xcotton-checkout-without { ${hidden} }
        #CartDrawer .wt-cart__drawer__footer { padding-top:12px!important; padding-bottom:14px!important; }
        #CartDrawer .shopify-cart-shipping-row-container { margin-bottom:8px!important; padding:0!important; }
        #CartDrawer .cart-shipping-main-row { min-height:0!important; height:auto!important; padding:0!important; }
        #CartDrawer .giftnote__drawercart__addnote { font-size:12px!important; line-height:1.2!important; }
        #CartDrawer #xcottonWrapper .xcotton-container { margin-top:8px!important; margin-bottom:8px!important; padding-top:10px!important; padding-bottom:10px!important; }
        #CartDrawer #xcottonWrapper .hd_box { margin-bottom:4px!important; }
        #CartDrawer #xcottonWrapper .xcotton-content,
        #CartDrawer #xcottonWrapper .xcotton-content-text { height:auto!important; min-height:0!important; line-height:16px!important; }
        #CartDrawer #xcottonWrapper .xcotton-content-text p { margin:0!important; line-height:16px!important; }
        #CartDrawer #xcottonWrapper .xcotton-content-text br { display:none!important; }
        #CartDrawer #xcottonWrapper .xcotton-content-text p+p { margin-top:2px!important; }
        #CartDrawer .wt-cart__footer__body { padding-top:8px!important; }
        #CartDrawer .wt-cart__subtotal__value,
        #CartDrawer .totals__subtotal-value,
        #CartDrawer .totals__total-value { font-size:18px!important; line-height:1.05!important; }
        #CartDrawer .wt-cart__subtitle__text,
        #CartDrawer .tax-note,
        #CartDrawer .cart__ctas+small { font-size:10px!important; line-height:1.25!important; margin:2px 0 10px!important; }
        #CartDrawer .btn-checkout.wt-cart__cta>.svg-icon,
        #CartDrawer .btn-checkout.wt-cart__cta>svg,
        #CartDrawer .btn-checkout.wt-cart__cta svg.svg-icon { display:none!important; visibility:hidden!important; width:0!important; height:0!important; margin:0!important; padding:0!important; }
        #CartDrawer .wt-cart__drawer__header { min-height:52px!important; padding-top:12px!important; padding-bottom:8px!important; }
        #CartDrawer #CartDrawer-TotalQty,
        #CartDrawer .wt-cart__drawer__title,
        #CartDrawer .drawer__heading,
        #CartDrawer h2 { font-size:20px!important; line-height:1!important; font-weight:400!important; letter-spacing:0!important; gap:5px!important; }
        #CartDrawer .wt-cart__drawer-title-count { font-size:11px!important; line-height:1!important; margin-left:2px!important; transform:translateY(-.42em)!important; }
        #CartDrawer .wt-cart__drawer__body .wt-cart__item { padding-top:12px!important; }
        #CartDrawer .wt-cart__item__name,
        #CartDrawer .cart-item__name,
        #CartDrawer .cart-item__details>a { font-size:16px!important; line-height:1.22!important; letter-spacing:0!important; }
        #CartDrawer .wt-cart__item__body .options,
        #CartDrawer .wt-cart__item__body .product-option,
        #CartDrawer .cart-item__details dl,
        #CartDrawer .cart-item__details .product-option,
        #CartDrawer .wt-cart__item__variant,
        #CartDrawer .wt-cart__item__option,
        #CartDrawer .wt-cart__item__options,
        #CartDrawer .wt-cart__item__properties,
        #CartDrawer .wt-cart__item-discount,
        #CartDrawer .discounts { font-size:13px!important; line-height:1.35!important; letter-spacing:0!important; }
        #CartDrawer .quantity,
        #CartDrawer .counter,
        #CartDrawer quantity-input,
        #CartDrawer .cart-quantity { width:84px!important; max-width:84px!important; height:35px!important; min-height:35px!important; border-radius:18px!important; border-width:.5px!important; box-shadow:none!important; display:grid!important; grid-template-columns:26px 32px 26px!important; align-items:center!important; }
        #CartDrawer .quantity__button,
        #CartDrawer .counter__button,
        #CartDrawer .counter button,
        #CartDrawer quantity-input button { width:26px!important; min-width:26px!important; height:35px!important; min-height:35px!important; padding:0!important; }
        #CartDrawer .quantity__input,
        #CartDrawer .counter__input,
        #CartDrawer .counter input,
        #CartDrawer quantity-input input { width:32px!important; height:35px!important; min-height:35px!important; line-height:35px!important; font-size:16px!important; text-align:center!important; padding:0!important; margin:0!important; }
        #CartDrawer .wt-cart__subtotal { align-items:center!important; }
        #CartDrawer .wt-cart__subtotal__value,
        #CartDrawer .totals__subtotal-value,
        #CartDrawer .totals__total-value { color:#1e372f!important; align-self:center!important; }
        #CartDrawer .btn-checkout.wt-cart__cta:not(.xcotton-checkout-without)::after { content:'CHECKOUT'!important; display:block!important; width:100%!important; text-align:center!important; }
      }

      @media screen and (min-width: 750px) {
        #CartDrawer .xctton-side-cart-offer,
        #CartDrawer .xctton-side-cart-offer-btn,
        #CartDrawer .xcotton-checkout-without,
        #CartDrawer .wt-cart__footer__body>.xcotton-checkout-without { ${hidden} }
      }

      @media screen and (min-width: 1024px) {
        #CartDrawer.drawer,
        #CartDrawer.wt-cart__drawer,
        #CartDrawer { left:auto!important; right:0!important; width:min(560px,72vw)!important; max-width:560px!important; }
        #CartDrawer .wt-cart__drawer__header { min-height:76px!important; padding:24px 30px 12px!important; border-bottom:0!important; }
        #CartDrawer #CartDrawer-TotalQty,
        #CartDrawer .wt-cart__drawer__title,
        #CartDrawer .drawer__heading,
        #CartDrawer h2 { font-size:28px!important; line-height:1!important; font-weight:400!important; letter-spacing:0!important; gap:8px!important; }
        #CartDrawer .wt-cart__drawer-title-count { font-size:14px!important; line-height:1!important; margin-left:4px!important; transform:translateY(-.34em)!important; }
        #CartDrawer .wt-cart__drawer__close--button,
        #CartDrawer .drawer__close,
        #CartDrawer button[name="close"] { width:30px!important; height:30px!important; min-width:30px!important; min-height:30px!important; margin-top:-5px!important; }
        #CartDrawer .wt-cart__drawer__close--button svg,
        #CartDrawer .drawer__close svg,
        #CartDrawer button[name="close"] svg { width:30px!important; height:30px!important; stroke-width:1.5!important; }
        #CartDrawer .wt-cart__drawer__body { padding:0 30px!important; }
        #CartDrawer .wt-cart__drawer__body .wt-cart__item { grid-template-columns:124px minmax(0,1fr)!important; gap:30px!important; padding:18px 0 28px!important; }
        #CartDrawer .wt-cart__drawer__body .wt-cart__item+.wt-cart__item { border-top:1px solid #dedede!important; }
        #CartDrawer .wt-cart__item__thumb,
        #CartDrawer .wt-cart__item__image,
        #CartDrawer .cart-item__media { width:124px!important; min-width:124px!important; max-width:124px!important; flex-basis:124px!important; }
        #CartDrawer .wt-cart__item__thumb img,
        #CartDrawer .wt-cart__item__image img,
        #CartDrawer .cart-item__image,
        #CartDrawer .cart-item__media img { width:124px!important; height:124px!important; aspect-ratio:1/1!important; object-fit:cover!important; }
        #CartDrawer .wt-cart__item__body { min-width:0!important; padding-top:3px!important; }
        #CartDrawer .wt-cart__item__name,
        #CartDrawer .cart-item__name,
        #CartDrawer .cart-item__details>a { font-size:20px!important; line-height:1.22!important; font-weight:400!important; letter-spacing:0!important; margin:0!important; }
        #CartDrawer .wt-cart__item__body .options,
        #CartDrawer .wt-cart__item__body .product-option,
        #CartDrawer .cart-item__details dl,
        #CartDrawer .cart-item__details .product-option,
        #CartDrawer .wt-cart__item__variant,
        #CartDrawer .wt-cart__item__option,
        #CartDrawer .wt-cart__item__options,
        #CartDrawer .wt-cart__item__properties { font-size:15px!important; line-height:1.34!important; font-weight:400!important; letter-spacing:0!important; margin-top:12px!important; color:#7b7b7b!important; }
        #CartDrawer .wt-cart__item__body .options *,
        #CartDrawer .cart-item__details dl *,
        #CartDrawer .cart-item__details .product-option * { font-size:15px!important; line-height:1.34!important; letter-spacing:0!important; }
        #CartDrawer .wt-cart__item-discount,
        #CartDrawer .cart-item__discounted-prices,
        #CartDrawer .cart-item__discounts,
        #CartDrawer .discounts { font-size:15px!important; line-height:1.25!important; margin-top:6px!important; color:#2f5d3b!important; letter-spacing:0!important; }
        #CartDrawer .wt-cart__item__amount.cart-page,
        #CartDrawer .cart-item__quantity,
        #CartDrawer .cart-item__quantity-wrapper { display:grid!important; grid-template-columns:minmax(0,1fr) 148px!important; align-items:center!important; column-gap:20px!important; margin-top:20px!important; }
        #CartDrawer .quantity,
        #CartDrawer .counter,
        #CartDrawer quantity-input,
        #CartDrawer .cart-quantity { width:84px!important; max-width:84px!important; height:30px!important; min-height:30px!important; border-radius:15px!important; border-width:.67px!important; border-color:#ddd!important; box-shadow:none!important; display:grid!important; grid-template-columns:26px 32px 26px!important; align-items:center!important; justify-content:start!important; }
        #CartDrawer .quantity__button,
        #CartDrawer .counter__button,
        #CartDrawer .counter button,
        #CartDrawer quantity-input button { width:26px!important; min-width:26px!important; height:30px!important; min-height:30px!important; font-size:13px!important; line-height:30px!important; padding:0!important; }
        #CartDrawer .quantity__button svg,
        #CartDrawer .counter__button svg,
        #CartDrawer .counter button svg,
        #CartDrawer quantity-input button svg { width:10px!important; height:10px!important; stroke-width:1.4!important; }
        #CartDrawer .quantity__input,
        #CartDrawer .counter__input,
        #CartDrawer .counter input,
        #CartDrawer quantity-input input { width:32px!important; height:30px!important; min-height:30px!important; font-size:14px!important; line-height:30px!important; text-align:center!important; padding:0!important; margin:0!important; }
        #CartDrawer .wt-cart__item__remove,
        #CartDrawer .wt-cart__item__remove--amount,
        #CartDrawer .cart-remove-button,
        #CartDrawer cart-remove-button { width:22px!important; height:22px!important; min-width:22px!important; min-height:22px!important; }
        #CartDrawer .wt-cart__item__remove svg,
        #CartDrawer .wt-cart__item__remove--amount svg,
        #CartDrawer .cart-remove-button svg,
        #CartDrawer cart-remove-button svg { width:22px!important; height:22px!important; stroke-width:1.4!important; }
        #CartDrawer .wt-cart__item__price-wrapper,
        #CartDrawer .cart-item__price-wrapper,
        #CartDrawer .cart-item__totals { min-width:148px!important; max-width:148px!important; width:148px!important; justify-self:end!important; text-align:right!important; font-weight:400!important; }
        #CartDrawer .wt-cart__item__old-price,
        #CartDrawer .cart-item__old-price,
        #CartDrawer .cart-item__price-wrapper s,
        #CartDrawer .price--end s,
        #CartDrawer .cart-item__discounted-prices s { font-size:14px!important; line-height:1.15!important; font-weight:400!important; letter-spacing:0!important; }
        #CartDrawer .wt-cart__item__price,
        #CartDrawer .cart-item__final-price,
        #CartDrawer .cart-item__price-wrapper .price,
        #CartDrawer .price--end,
        #CartDrawer .price { font-size:17px!important; line-height:1.18!important; font-weight:400!important; letter-spacing:0!important; }
        #CartDrawer .wt-cart__item__price-wrapper .cart-item__old-price.price.price--end,
        #CartDrawer .cart-item__price-wrapper .cart-item__old-price.price.price--end,
        #CartDrawer .wt-cart__item__price-wrapper s.price.price--end,
        #CartDrawer .cart-item__price-wrapper s.price.price--end { font-size:15px!important; line-height:1.15!important; font-weight:400!important; letter-spacing:0!important; }
        #CartDrawer .wt-cart__item__price-wrapper span.price.price--end,
        #CartDrawer .cart-item__price-wrapper span.price.price--end,
        #CartDrawer .wt-cart__item__price-wrapper .cart-item__discounted-prices>span.price,
        #CartDrawer .cart-item__price-wrapper .cart-item__discounted-prices>span.price { font-size:17px!important; line-height:1.18!important; font-weight:400!important; letter-spacing:0!important; }
        #CartDrawer .wt-cart__drawer__footer { padding:0 30px clamp(34px,4vh,48px)!important; box-sizing:border-box!important; border-top:1px solid #dedede!important; }
        html.ellerow-shopify-preview-bar-active #CartDrawer .wt-cart__drawer__footer { padding-bottom:clamp(68px,6.8vh,78px)!important; }
        #CartDrawer .cart-shipping-main-row { min-height:68px!important; height:68px!important; padding:0!important; align-items:center!important; }
        #CartDrawer #xcottonWrapper .xcotton-container { margin-top:7px!important; margin-bottom:7px!important; padding-top:6px!important; padding-bottom:6px!important; }
        #CartDrawer #xcottonWrapper .hd_box { margin-bottom:3px!important; }
        #CartDrawer #xcottonWrapper .xcotton-content,
        #CartDrawer #xcottonWrapper .xcotton-content-text { height:auto!important; min-height:0!important; line-height:16px!important; }
        #CartDrawer #xcottonWrapper .xcotton-content-text p { margin:0!important; line-height:16px!important; }
        #CartDrawer #xcottonWrapper .xcotton-content-text br { display:none!important; }
        #CartDrawer .giftnote__drawercart__addnote,
        #CartDrawer .ellerow-desktop-view-cart { font-size:20px!important; line-height:1.1!important; font-weight:400!important; letter-spacing:0!important; }
        #CartDrawer .ellerow-desktop-view-cart { align-self:center!important; transform:translateY(-2px)!important; }
        #CartDrawer .wt-cart__footer__body { padding-top:24px!important; }
        #CartDrawer .wt-cart__subtotal { align-items:center!important; margin:0!important; }
        #CartDrawer .wt-cart__subtotal__label,
        #CartDrawer .wt-cart__subtotal__label .text { font-size:20px!important; line-height:1.2!important; font-weight:400!important; letter-spacing:0!important; }
        #CartDrawer .wt-cart__subtotal__value,
        #CartDrawer .totals__subtotal-value,
        #CartDrawer .totals__total-value { color:#1e372f!important; font-size:27px!important; line-height:1.08!important; font-weight:400!important; letter-spacing:0!important; align-self:center!important; }
        #CartDrawer .wt-cart__subtitle__text,
        #CartDrawer .tax-note,
        #CartDrawer .cart__ctas+small { font-size:14px!important; line-height:1.2!important; font-weight:400!important; letter-spacing:0!important; margin:4px 0 14px!important; }
        #CartDrawer .wt-cart__cta:not(.xcotton-checkout-without),
        #CartDrawer .btn-checkout.wt-cart__cta:not(.xcotton-checkout-without),
        #CartDrawer .cart__checkout-button:not(.xcotton-checkout-without),
        #CartDrawer button[name="checkout"]:not(.xcotton-checkout-without) { height:56px!important; min-height:56px!important; max-height:56px!important; border-radius:28px!important; padding:0 28px!important; width:100%!important; margin:0!important; display:flex!important; align-items:center!important; justify-content:center!important; visibility:visible!important; opacity:1!important; color:transparent!important; font-size:0!important; line-height:0!important; }
        #CartDrawer .btn-checkout.wt-cart__cta:not(.xcotton-checkout-without)::after { content:'CHECKOUT'!important; display:block!important; width:100%!important; text-align:center!important; visibility:visible!important; opacity:1!important; color:#fff!important; font-size:22px!important; line-height:1!important; font-weight:400!important; letter-spacing:.04em!important; }
        #CartDrawer .wt-cart__cta:not(.xcotton-checkout-without) *,
        #CartDrawer .cart__checkout-button:not(.xcotton-checkout-without) *,
        #CartDrawer button[name="checkout"]:not(.xcotton-checkout-without) * { font-size:0!important; line-height:0!important; color:transparent!important; }
      }`;
    document.head.appendChild(style);
    stripCartTaxNoteLinks();
    normalizeCartTitle();
    syncEmptyCartFontClass();
    syncCartTitleSoon();
    bindCartTitleSync();
    bindCartNoteFallback();
  }

  function load() {
    if (window.__ellerowCartPolishV5Loaded) {
      inject();
      return;
    }

    const script = document.createElement('script');
    script.src = baseUrl();
    script.defer = true;
    script.onload = function () {
      window.__ellerowCartPolishV5Loaded = true;
      inject();
    };
    script.onerror = inject;
    document.head.appendChild(script);
  }

  function later() {
    setTimeout(inject, 0);
    setTimeout(inject, 800);
  }

  load();
  window.addEventListener('resize', inject);
  window.addEventListener('load', later);
  document.addEventListener('cart-drawer:refresh', later);
  document.addEventListener('cart-drawer:open', later);
})();
